export default __webpack_public_path__ + "8927bea64b925bb72ed2e4ef213ffe61.jpeg";